class ToggledList {
    constructor(el) {
        if (!this.set(el)) return;
        this.activeIndex = 0;
        this.init();
    }

    set(el) {
        this.root = el;
        this.toggleButtonEl = this.root.querySelectorAll(
            '[data-toggled-list-toggle]'
        );
        this.listEl = this.root.querySelectorAll('[data-toggled-list-list]');
        this.imageEl = this.root.querySelectorAll('[data-toggled-list-image]');
        this.badgeEl = this.root.querySelectorAll('[data-toggled-list-badges]');
        return true;
    }

    init() {
        this.toggleButtonEl.forEach(btn => {
            btn.addEventListener('click', () => {
                const index = parseInt(btn.dataset.toggledListToggle);
                if (index === this.activeIndex) return;

                this.change(index);
            });
        });
    }

    change(index) {
        this.updateButtons(index);
        this.toggleFade(this.listEl, index);
        this.toggleFade(this.imageEl, index);
        this.toggleSlide(this.badgeEl, index);

        this.activeIndex = index;
    }

    updateButtons(index) {
        this.toggleButtonEl.forEach(btn => btn.classList.remove('-active'));
        this.toggleButtonEl[index].classList.add('-active');
    }

    toggleFade(elements, activeIndex) {
        elements.forEach(el => {
            const elIndex = parseInt(
                el.dataset.toggledListImage ?? el.dataset.toggledListList
            );

            if (elIndex === activeIndex) {
                el.classList.remove('opacity-0', 'pointer-events-none');
                el.classList.add('opacity-100');
            } else {
                el.classList.remove('opacity-100');
                el.classList.add('opacity-0', 'pointer-events-none');
            }
        });
    }

    toggleSlide(elements, activeIndex) {
        elements.forEach(el => {
            const elIndex = parseInt(el.dataset.toggledListBadges);

            if (elIndex === activeIndex) {
                el.classList.remove(
                    'opacity-0',
                    'translate-x-8',
                    'pointer-events-none'
                );
                el.classList.add('opacity-100', 'translate-x-0');
            } else {
                el.classList.remove('opacity-100', 'translate-x-0');
                el.classList.add(
                    'opacity-0',
                    'translate-x-8',
                    'pointer-events-none'
                );
            }
        });
    }
}
const initToggledList = () => {
    const sections = document.querySelectorAll('[data-toggled-list]');

    if (sections.length) {
        sections.forEach(item => new ToggledList(item));
    }
};

initToggledList();
